export enum ChartType {
  trend = 1,
  workspace = 2,
  pie = 3,
  historical = 4,
  schematic = 5,
  editable = 6,
  customizable = 7,
}
